<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
    <div class="w-full rounded-lg shadow body-element">

      <div class="card-header">
        <div class="page-titles">
          <h4>Meilleures sellers par commandes</h4>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)">Account manager: </a></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">{{ currentUser.fullName }}</a></li><br>
            <li v-if="nbSellers" class="breadcrumb-item"><a href="javascript:void(0)">Nombre Sellers affected: </a></li>
            <li v-if="nbSellers" class="breadcrumb-item active"><a href="javascript:void(0)">{{ nbSellers }}</a></li>
          </ol>
        </div>
        <div class="">
          <date-picker :disabled="loading" @change="DateRange" placeholder="Date ..." format="YYYY-MM-DD"
            class="w-full-imp" v-model="formData.date" range></date-picker>
          <button :disabled="loading" @click="downloadCsv" class="dt-button buttons-excel buttons-html5"><svg width="16"
              height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="fill-current mr-2">
              <path d="M23 0v20h-8v-2h6v-16h-18v16h6v2h-8v-20h22zm-12 13h-4l5-6 5 6h-4v11h-2v-11z"></path>
            </svg><span>Excel</span></button>
        </div>
      </div>

      <div class="mt-5 mx-5 pb-5 relative" style="overflow-x: auto;">
        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <table id="payment-tab" class="responsive-table relative">
          <thead class="ant-table-thead">
            <tr>
              <th style="position: sticky; left: 0px;" :rowspan="ordersByseller.length > 0 ? 3 : ''"
                class="ant-table-cell-fix-right-first ant-table-cell-fix-right">Seller</th>
              <th style="white-space: nowrap;" :rowspan="ordersByseller.length > 0 ? 3 : ''">Nombre ordres uploaded</th>
              <th :colspan="ordersByseller.length > 0 ? ordersByseller[0][1].length * 9 + 1 : ''">Warehouses</th>
              <!-- <th :rowspan="ordersByseller.length>0?3:''">Payment method</th>
                        <th style="position: sticky; right: 0px;" class="ant-table-cell-fix-right-first ant-table-cell-fix-right" :rowspan="ordersByseller.length>0?3:''">Action</th> -->
            </tr>
            <tr v-if="ordersByseller.length > 0" class="warehouses intro-x">
              <th v-for="(item, index) in ordersByseller[0][1]" :key="'header-' + index" :colspan="9"><img
                  v-if="item.flag" :src="item.flag" class="w-4 inline-block h-4 rounded-full mr-2"> {{ item.name }} </th>
            </tr>

            <tr v-if="ordersByseller.length > 0" class="orders intro-x">
              <template v-for="(item1) in ordersByseller[0][1]">
                <th>Confirmed</th>
                <th>Cancelled</th>
                <th>Reminded</th>
                <th>Unrached (CALLS)</th>
                <th>Shipped</th>
                <th>Reprogrammer</th>
                <th>Return</th>
                <th>Paid</th>
                <th>Processed</th>
              </template>
            </tr>
          </thead>
          <tbody v-if="ordersByseller.length == 0" class="relative">
            <tr class="intro-x empty-tab">
              <td colspan="4" class="text-center-imp padding-empty uppercase">
                <span v-if="loading"> Loading Data ... <img class="img-paym" :src="spinner" /></span>
                <span v-else> Aucune donnée disponible </span>
              </td>
            </tr>
          </tbody>
          <tbody v-if="ordersByseller.length > 0" class="relative">
            <tr v-for="(ele, index) in ordersByseller" :key="'seller-' + index" class="intro-x">
              <td style="width: 200px;white-space: nowrap;position: sticky; left: 0px;" scope="row"
                class="text-left-imp font-bold text-gray-700 fz-14 ant-table-cell-fix-right ant-table-cell-fix-right-first">
                <!-- <div v-if="!ele[2].userData" class="spinner-g">
                              <div class="spinner-1"></div>
                              <div class="spinner-2"></div>
                              <div class="spinner-3"></div>
                          </div> -->
                <div><moukhtar-avatar inline :username="ele[3]" :size="30"></moukhtar-avatar> {{ ele[3] }}</div>
              </td>
              <td style="width: 200px;white-space: nowrap;" scope="row"
                class="text-left-imp font-bold text-gray-700 fz-14">
                {{ ele[2] }}
                <span class="flex">
                  <span
                    v-for="(ware, index) in ele[1].filter(ts => (ts.sumConfirmed + ts.sumRemind + ts.sumUnreached + ts.sumCancelled + ts.sumShipped + ts.sumReprogrammer + ts.sumReturn + ts.sumProcessed))"
                    :key="'werrr-' + index" class="intro-x">
                    <img :src="ware.flag" class="w-4 h-4 rounded-full mr-2">
                  </span>
                </span>
              </td>

              <template v-for="(item2) in ele[1]">
                <td :style="randomHexColor(item2.index)" :class="item2.sumConfirmed ? '' : 'empty-row'">
                  {{ item2.sumConfirmed ? item2.sumConfirmed : '' }}</td>
                <td :style="randomHexColor(item2.index)" :class="item2.sumCancelled ? '' : 'empty-row'">
                  {{ item2.sumCancelled ? item2.sumCancelled : '' }}</td>
                <td :style="randomHexColor(item2.index)" :class="item2.sumRemind ? '' : 'empty-row'">
                  {{ item2.sumRemind ? item2.sumRemind : '' }}</td>
                <td :style="randomHexColor(item2.index)" :class="item2.sumUnreached ? '' : 'empty-row'">
                  {{ item2.sumUnreached ? item2.sumUnreached : '' }}</td>
                <td :style="randomHexColor(item2.index)" :class="item2.sumShipped ? '' : 'empty-row'">
                  {{ item2.sumShipped ? item2.sumShipped : '' }}</td>
                <td :style="randomHexColor(item2.index)" :class="item2.sumReprogrammer ? '' : 'empty-row'">
                  {{ item2.sumReprogrammer ? item2.sumReprogrammer : '' }}</td>
                <td :style="randomHexColor(item2.index)" :class="item2.sumReturn ? '' : 'empty-row'">
                  {{ item2.sumReturn ? item2.sumReturn : '' }}</td>
                <td :style="randomHexColor(item2.index)" :class="item2.sumPaid ? '' : 'empty-row'">
                  {{ item2.sumPaid ? item2.sumPaid : '' }}</td>
                <td :style="randomHexColor(item2.index)" :class="item2.sumProcessed ? '' : 'empty-row'">
                  {{ item2.sumProcessed ? item2.sumProcessed : '' }}</td>
              </template>
              <!-- <td>
                          
                      </td> -->
              <!-- <td style="position: sticky; right: 0px;" class="ant-table-cell-fix-right ant-table-cell-fix-right-first"></td> -->
            </tr>
          </tbody>

        </table>
      </div>

      <dialog class="printingExcel">
        <modal-export-excel-orders :items="ordersByseller" type="PaymentsByseller" />
      </dialog>
      <vue-modal-2 name="modaldate" :headerOptions="{ title: 'Validation date' }" :noFooter="true" modalSize="md"
        @on-close="$vm2.close('modaldate')">
        <div class="flex flex-col w-full h-auto">
          <!-- Header -->
          <!-- Modal Content-->
          <div class="bg-white rounded px-2  pb-2 flex flex-col">
            <p class="font-bold text-center">Etes-vous sûr de faire le filtrage avec cette range date ?</p>

            <div class="flex p-2 mt-4">
              <div class="flex-auto flex flex-row-reverse">
                <button @click="getOrders()"
                  class="w-1/3 p-3 btn-action rounded bg-green-600 hover:bg-green-500 text-white font-semibold focus:outline-none">
                  Confirm</button>
                <button @click="$vm2.close('modaldate');"
                  class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
              </div>
            </div>
          </div>
          <!-- End of Modal Content-->
        </div>
      </vue-modal-2>

    </div>
  </div>
</template>




<script>
import spinner from "@/assets/spinner.gif";;
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      loading: false,
      fullPage: false,
      loadingShowPay: 0,
      ordersByseller: [],
      nbSellers: 0,
      loadingShowPay: false,
      spinner: spinner,
      formData: { datas: [], date: [this.$moment(new Date(this.$moment().format('YYYY-MM-DD hh:mm')), 'LL').toDate(), this.$moment(new Date(this.$moment().format('YYYY-MM-DD hh:mm')), 'LL').toDate()] }
    };
  },
  async mounted() {
    await this.getOrders();
  },
  methods: {
    randomHexColor(index) {
      const colors = ["#ba96ce", "#679c9d", "#c6c42c", "#48b41b", "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf", "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234", "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158", "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647", "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3", "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52",];
      return 'background: ' + colors[index];
    },
    async getOrders() {
      this.$vm2.close('modaldate');
      this.loading = true;
      let { content: res } = await this.$server.search("orders", { actionData: "ManagerOrdersAnalytics", Range_date: this.formData.date });
      this.loading = false;
      console.log('res 11----------', res.data)
      if (res && res.data) {
        this.ordersByseller = [];
        res.data = res.data.sort(function (a, b) { return b[2] - a[2]; });
        this.ordersByseller = res.data;
        this.nbSellers = res.sellers;
      } else return this.$toast.warning(res);

    },
    DateRange(data) {
      console.log('data date-------------------', data)
      if (data && data.filter(e => e).length === 0) {
        this.$toast.warning('Date Range obligatoir, svp selectioné une date');
        return false
      }
      if (data) this.$vm2.open('modaldate');
    },
    downloadCsv: function () {
      //this.dataExcel=[];
      if (this.ordersByseller.length > 0) {
        var nameTable = "SellersOrders";
        var htmls = "";
        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
        var base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)))
        };

        var format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          })
        };
        const table = document.getElementById("p-table");
        htmls = table.outerHTML
        var ctx = {
          worksheet: nameTable,
          table: htmls
        }

        var link = document.createElement("a");
        link.download = nameTable + ".xls";
        link.href = uri + base64(format(template, ctx));
        link.click();
      };
    },
  },
};
</script>

<style scoped>
.ant-table-cell-fix-right {
  position: -webkit-sticky !important;
  position: sticky !important;
  z-index: 2;
  background: #fff;
}

.ant-table-cell-fix-right-first:before,
.ant-table-cell-fix-right-last:before {
  /* position: absolute;
    top: 0;
    bottom: -1px;
    right: 0;
    width: 30px;
    transform: translateX(60%);
    transition: box-shadow .3s;
    content: "";
    pointer-events: none;
    box-shadow: inset -10px 0 8px -8px rgb(0 0 0 / 15%); */
}

.buttons-excel {
  border: 1px solid rgb(89, 91, 94);
  background: rgba(255, 255, 255, 0.15);
  position: relative;
  box-sizing: border-box;
  padding: 9px 1em;
  border-radius: 2px;
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none;
  outline: none;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: .88em;
  line-height: 1em;
  display: flex;
  float: right;
  margin-top: 15px;
}

.card-header svg {
  display: inline-block;
}

.img-paym {
  display: inline-block;
  width: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 1.5rem 1.875rem 1.25rem;
}

.page-titles .breadcrumb {
  margin-bottom: 0;
  padding: 0;
  background: transparent;
}

.page-titles .breadcrumb li {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 18px;
  display: inline-block;
}

.breadcrumb-item.active {
  color: #6c757d;
}

.breadcrumb-item+.breadcrumb-item {
  padding-left: 0.5rem;
}

.page-titles .breadcrumb li.active a {
  color: #007A64;
  font-weight: 600;
  text-transform: uppercase;
}

.page-titles .breadcrumb li {
  font-size: 18px;
}

.body-element {
  background-color: #F9F9F9;
}

.page-titles {
  margin-top: 0px;
  margin-bottom: 30px;
  margin-right: auto;
}

.page-titles h4,
.page-titles .h4 {
  margin-bottom: 10px;
  margin-top: 0;
  color: #000;
  font-size: 1.75rem;
  font-weight: 600;
}

table>thead>tr:first-child th:last-child {
  border-top-right-radius: 4px;
}

.ant-table-cell-fix-right {
  position: -webkit-sticky !important;
  position: sticky !important;
  z-index: 2;
  background: #fff;
}

.ant-table-thead>tr>th {
  background: rgb(203 213 224);
}

.ant-table-cell-fix-right-first:after,
.ant-table-cell-fix-right-last:after {
  position: absolute;
  top: 0;
  bottom: -1px;
  left: 0;
  width: 30px;
  transform: translateX(-100%);
  transition: box-shadow .3s;
  content: "";
  pointer-events: none;
  box-shadow: inset -10px 0 8px -8px rgb(0 0 0 / 15%);
}

.empty-row {
  /* background: repeating-linear-gradient(53deg,#bfc0c2 4%,#fcfcff 11px 6%,#fff 0 7%,#9d9c9c 15px) !important; */
  background: repeating-linear-gradient(45deg, #FFFFFF, #FFFFFF 10px, #DDDDDD 10px, #DDDDDD 20px) !important;
}

.text-left-imp {
  text-align: left !important;
}

.fz-14 {
  font-size: 14px;
}

hr {
  display: block;
  unicode-bidi: isolate;
  margin-block-start: 0.5em;
  margin-block-end: 0.5em;
  margin-inline-start: auto;
  margin-inline-end: auto;
  overflow: hidden;
  border-style: inset;
  border-width: 1px;
}

table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}

.px-5-im {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.empty-tab {
  height: 200px;
}

.text-center-imp {
  text-align: center !important;
}

.form-payement {
  min-height: 40rem
}

th,
td {
  padding: 5px;
  text-align: center;
}

.responsive-table {
  width: 100%;
  border-collapse: separate;
  text-indent: initial;
  border-spacing: 2px;
}

.warehouses th {
  background-color: #efeff0 !important;
  color: #090909 !important;
}

.orders th {
  background-color: #a4a3a3 !important;
  color: black !important;
  font-size: 10px;
  font-weight: 700 !important;
}

.responsive-table thead {
  position: relative;
  clip: auto;
  height: auto;
  width: auto;
  overflow: auto;
}

.responsive-table thead th {
  background-color: #007A64;
  border: 1px solid #4e504a;
  font-weight: 500;
  color: #faf4f4;
}

.responsive-table thead th:first-of-type {
  text-align: center;
}

.responsive-table tr {
  display: table-row;
}

.responsive-table th,
.responsive-table td {
  padding: 3px;
  vertical-align: middle;
  display: table-cell;
}

.spinner-g .spinner-1 {
  animation: fade 1.1s ease-in-out 0.18s infinite both;
}

.spinner-g .spinner-2 {
  animation: fade 1.1s ease-in-out 0.36s infinite both;
}

.spinner-g .spinner-3 {
  animation: fade 1.1s ease-in-out 0.54s infinite both;
}

.spinner-g * {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-color: #007A64;
  border-radius: 1rem;
  margin: 0 0.2rem;
}

@keyframes fade {
  0% {
    opacity: 0.35;
    transform: scale(0.87);
  }

  37.5% {
    opacity: 1;
    transform: scale(1);
  }

  75% {
    opacity: 0.35;
    transform: scale(0.87);
  }

  100% {
    opacity: 0.35;
    transform: scale(0.87);
  }
}

*>.intro-x:first-child {
  transform: translateX(50px)
}

*>.-intro-x:first-child,
*>.intro-x:first-child {
  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .1s;
  animation-delay: .1s
}

*>.-intro-x:first-child {
  transform: translateX(-50px)
}

*>.intro-y:first-child {
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .1s;
  animation-delay: .1s
}

*>.intro-x:nth-child(2) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(2),
*>.intro-x:nth-child(2) {
  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .2s;
  animation-delay: .2s
}

*>.-intro-x:nth-child(2) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(2) {
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .2s;
  animation-delay: .2s
}

*>.intro-x:nth-child(3) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(3),
*>.intro-x:nth-child(3) {
  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .3s;
  animation-delay: .3s
}

*>.-intro-x:nth-child(3) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(3) {
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .3s;
  animation-delay: .3s
}

*>.intro-x:nth-child(4) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(4),
*>.intro-x:nth-child(4) {
  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .4s;
  animation-delay: .4s
}

*>.-intro-x:nth-child(4) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(4) {
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .4s;
  animation-delay: .4s
}

*>.intro-x:nth-child(5) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(5),
*>.intro-x:nth-child(5) {
  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .5s;
  animation-delay: .5s
}

*>.-intro-x:nth-child(5) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(5) {
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .5s;
  animation-delay: .5s
}

*>.intro-x:nth-child(6) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(6),
*>.intro-x:nth-child(6) {
  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .6s;
  animation-delay: .6s
}

*>.-intro-x:nth-child(6) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(6) {
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .6s;
  animation-delay: .6s
}

*>.intro-x:nth-child(7) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(7),
*>.intro-x:nth-child(7) {
  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .7s;
  animation-delay: .7s
}

*>.-intro-x:nth-child(7) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(7) {
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .7s;
  animation-delay: .7s
}

*>.intro-x:nth-child(8) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(8),
*>.intro-x:nth-child(8) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .8s;
  animation-delay: .8s
}

*>.-intro-x:nth-child(8) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(8) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .8s;
  animation-delay: .8s
}

*>.intro-x:nth-child(9) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(9),
*>.intro-x:nth-child(9) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .9s;
  animation-delay: .9s
}

*>.-intro-x:nth-child(9) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(9) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .9s;
  animation-delay: .9s
}

*>.intro-x:nth-child(10) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(10),
*>.intro-x:nth-child(10) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1s;
  animation-delay: 1s
}

*>.-intro-x:nth-child(10) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(10) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1s;
  animation-delay: 1s
}

*>.intro-x:nth-child(11) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(11),
*>.intro-x:nth-child(11) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.1s;
  animation-delay: 1.1s
}

*>.-intro-x:nth-child(11) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(11) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.1s;
  animation-delay: 1.1s
}

*>.intro-x:nth-child(12) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(12),
*>.intro-x:nth-child(12) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.2s;
  animation-delay: 1.2s
}

*>.-intro-x:nth-child(12) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(12) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.2s;
  animation-delay: 1.2s
}

*>.intro-x:nth-child(13) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(13),
*>.intro-x:nth-child(13) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.3s;
  animation-delay: 1.3s
}

*>.-intro-x:nth-child(13) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(13) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.3s;
  animation-delay: 1.3s
}

*>.intro-x:nth-child(14) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(14),
*>.intro-x:nth-child(14) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.4s;
  animation-delay: 1.4s
}

*>.-intro-x:nth-child(14) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(14) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.4s;
  animation-delay: 1.4s
}

*>.intro-x:nth-child(15) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(15),
*>.intro-x:nth-child(15) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.5s;
  animation-delay: 1.5s
}

*>.-intro-x:nth-child(15) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(15) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.5s;
  animation-delay: 1.5s
}

*>.intro-x:nth-child(16) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(16),
*>.intro-x:nth-child(16) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.6s;
  animation-delay: 1.6s
}

*>.-intro-x:nth-child(16) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(16) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.6s;
  animation-delay: 1.6s
}

*>.intro-x:nth-child(17) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(17),
*>.intro-x:nth-child(17) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.7s;
  animation-delay: 1.7s
}

*>.-intro-x:nth-child(17) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(17) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.7s;
  animation-delay: 1.7s
}

*>.intro-x:nth-child(18) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(18),
*>.intro-x:nth-child(18) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.8s;
  animation-delay: 1.8s
}

*>.-intro-x:nth-child(18) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(18) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.8s;
  animation-delay: 1.8s
}

*>.intro-x:nth-child(19) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(19),
*>.intro-x:nth-child(19) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.9s;
  animation-delay: 1.9s
}

*>.-intro-x:nth-child(19) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(19) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 1.9s;
  animation-delay: 1.9s
}

*>.intro-x:nth-child(20) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(20),
*>.intro-x:nth-child(20) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2s;
  animation-delay: 2s
}

*>.-intro-x:nth-child(20) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(20) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2s;
  animation-delay: 2s
}

*>.intro-x:nth-child(21) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(21),
*>.intro-x:nth-child(21) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.1s;
  animation-delay: 2.1s
}

*>.-intro-x:nth-child(21) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(21) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.1s;
  animation-delay: 2.1s
}

*>.intro-x:nth-child(22) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(22),
*>.intro-x:nth-child(22) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.2s;
  animation-delay: 2.2s
}

*>.-intro-x:nth-child(22) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(22) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.2s;
  animation-delay: 2.2s
}

*>.intro-x:nth-child(23) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(23),
*>.intro-x:nth-child(23) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.3s;
  animation-delay: 2.3s
}

*>.-intro-x:nth-child(23) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(23) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.3s;
  animation-delay: 2.3s
}

*>.intro-x:nth-child(24) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(24),
*>.intro-x:nth-child(24) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.4s;
  animation-delay: 2.4s
}

*>.-intro-x:nth-child(24) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(24) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.4s;
  animation-delay: 2.4s
}

*>.intro-x:nth-child(25) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(25),
*>.intro-x:nth-child(25) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.5s;
  animation-delay: 2.5s
}

*>.-intro-x:nth-child(25) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(25) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.5s;
  animation-delay: 2.5s
}

*>.intro-x:nth-child(26) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(26),
*>.intro-x:nth-child(26) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.6s;
  animation-delay: 2.6s
}

*>.-intro-x:nth-child(26) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(26) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.6s;
  animation-delay: 2.6s
}

*>.intro-x:nth-child(27) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(27),
*>.intro-x:nth-child(27) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.7s;
  animation-delay: 2.7s
}

*>.-intro-x:nth-child(27) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(27) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.7s;
  animation-delay: 2.7s
}

*>.intro-x:nth-child(28) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(28),
*>.intro-x:nth-child(28) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.8s;
  animation-delay: 2.8s
}

*>.-intro-x:nth-child(28) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(28) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.8s;
  animation-delay: 2.8s
}

*>.intro-x:nth-child(29) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(29),
*>.intro-x:nth-child(29) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.9s;
  animation-delay: 2.9s
}

*>.-intro-x:nth-child(29) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(29) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 2.9s;
  animation-delay: 2.9s
}

*>.intro-x:nth-child(30) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(30),
*>.intro-x:nth-child(30) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3s;
  animation-delay: 3s
}

*>.-intro-x:nth-child(30) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(30) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3s;
  animation-delay: 3s
}

*>.intro-x:nth-child(31) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(31),
*>.intro-x:nth-child(31) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.1s;
  animation-delay: 3.1s
}

*>.-intro-x:nth-child(31) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(31) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.1s;
  animation-delay: 3.1s
}

*>.intro-x:nth-child(32) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(32),
*>.intro-x:nth-child(32) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.2s;
  animation-delay: 3.2s
}

*>.-intro-x:nth-child(32) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(32) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.2s;
  animation-delay: 3.2s
}

*>.intro-x:nth-child(33) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(33),
*>.intro-x:nth-child(33) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.3s;
  animation-delay: 3.3s
}

*>.-intro-x:nth-child(33) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(33) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.3s;
  animation-delay: 3.3s
}

*>.intro-x:nth-child(34) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(34),
*>.intro-x:nth-child(34) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.4s;
  animation-delay: 3.4s
}

*>.-intro-x:nth-child(34) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(34) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.4s;
  animation-delay: 3.4s
}

*>.intro-x:nth-child(35) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(35),
*>.intro-x:nth-child(35) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.5s;
  animation-delay: 3.5s
}

*>.-intro-x:nth-child(35) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(35) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.5s;
  animation-delay: 3.5s
}

*>.intro-x:nth-child(36) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(36),
*>.intro-x:nth-child(36) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.6s;
  animation-delay: 3.6s
}

*>.-intro-x:nth-child(36) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(36) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.6s;
  animation-delay: 3.6s
}

*>.intro-x:nth-child(37) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(37),
*>.intro-x:nth-child(37) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.7s;
  animation-delay: 3.7s
}

*>.-intro-x:nth-child(37) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(37) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.7s;
  animation-delay: 3.7s
}

*>.intro-x:nth-child(38) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(38),
*>.intro-x:nth-child(38) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.8s;
  animation-delay: 3.8s
}

*>.-intro-x:nth-child(38) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(38) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.8s;
  animation-delay: 3.8s
}

*>.intro-x:nth-child(39) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(39),
*>.intro-x:nth-child(39) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.9s;
  animation-delay: 3.9s
}

*>.-intro-x:nth-child(39) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(39) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 3.9s;
  animation-delay: 3.9s
}

*>.intro-x:nth-child(40) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(40),
*>.intro-x:nth-child(40) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4s;
  animation-delay: 4s
}

*>.-intro-x:nth-child(40) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(40) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4s;
  animation-delay: 4s
}

*>.intro-x:nth-child(41) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(41),
*>.intro-x:nth-child(41) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.1s;
  animation-delay: 4.1s
}

*>.-intro-x:nth-child(41) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(41) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.1s;
  animation-delay: 4.1s
}

*>.intro-x:nth-child(42) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(42),
*>.intro-x:nth-child(42) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.2s;
  animation-delay: 4.2s
}

*>.-intro-x:nth-child(42) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(42) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.2s;
  animation-delay: 4.2s
}

*>.intro-x:nth-child(43) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(43),
*>.intro-x:nth-child(43) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.3s;
  animation-delay: 4.3s
}

*>.-intro-x:nth-child(43) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(43) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.3s;
  animation-delay: 4.3s
}

*>.intro-x:nth-child(44) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(44),
*>.intro-x:nth-child(44) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.4s;
  animation-delay: 4.4s
}

*>.-intro-x:nth-child(44) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(44) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.4s;
  animation-delay: 4.4s
}

*>.intro-x:nth-child(45) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(45),
*>.intro-x:nth-child(45) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.5s;
  animation-delay: 4.5s
}

*>.-intro-x:nth-child(45) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(45) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.5s;
  animation-delay: 4.5s
}

*>.intro-x:nth-child(46) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(46),
*>.intro-x:nth-child(46) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.6s;
  animation-delay: 4.6s
}

*>.-intro-x:nth-child(46) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(46) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.6s;
  animation-delay: 4.6s
}

*>.intro-x:nth-child(47) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(47),
*>.intro-x:nth-child(47) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.7s;
  animation-delay: 4.7s
}

*>.-intro-x:nth-child(47) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(47) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.7s;
  animation-delay: 4.7s
}

*>.intro-x:nth-child(48) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(48),
*>.intro-x:nth-child(48) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.8s;
  animation-delay: 4.8s
}

*>.-intro-x:nth-child(48) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(48) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.8s;
  animation-delay: 4.8s
}

*>.intro-x:nth-child(49) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(49),
*>.intro-x:nth-child(49) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.9s;
  animation-delay: 4.9s
}

*>.-intro-x:nth-child(49) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(49) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 4.9s;
  animation-delay: 4.9s
}

*>.intro-x:nth-child(50) {
  transform: translateX(50px)
}

*>.-intro-x:nth-child(50),
*>.intro-x:nth-child(50) {

  opacity: 0;
  position: relative;
  -webkit-animation: intro-x-animation .4s ease-in-out .33333s;
  animation: intro-x-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 5s;
  animation-delay: 5s
}

*>.-intro-x:nth-child(50) {
  transform: translateX(-50px)
}

*>.intro-y:nth-child(50) {

  opacity: 0;
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 5s;
  animation-delay: 5s
}

@-webkit-keyframes intro-x-animation {
  to {
    opacity: 1;
    transform: translateX(0)
  }
}

@keyframes intro-x-animation {
  to {
    opacity: 1;
    transform: translateX(0)
  }
}

@-webkit-keyframes intro-y-animation {
  to {
    opacity: 1;
    transform: translateY(0)
  }
}

@keyframes intro-y-animation {
  to {
    opacity: 1;
    transform: translateY(0)
  }
}
</style>
